/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProposalMatchingUnreadCountResponse model module.
 * @module model/ProposalMatchingUnreadCountResponse
 * @version 1.0.0
 */
class ProposalMatchingUnreadCountResponse {
    /**
     * Constructs a new <code>ProposalMatchingUnreadCountResponse</code>.
     * @alias module:model/ProposalMatchingUnreadCountResponse
     */
    constructor() { 
        
        ProposalMatchingUnreadCountResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProposalMatchingUnreadCountResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProposalMatchingUnreadCountResponse} obj Optional instance to populate.
     * @return {module:model/ProposalMatchingUnreadCountResponse} The populated <code>ProposalMatchingUnreadCountResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProposalMatchingUnreadCountResponse();

            if (data.hasOwnProperty('unread_count')) {
                obj['unread_count'] = ApiClient.convertToType(data['unread_count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProposalMatchingUnreadCountResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProposalMatchingUnreadCountResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 投資提案未読数
 * @member {Number} unread_count
 */
ProposalMatchingUnreadCountResponse.prototype['unread_count'] = undefined;






export default ProposalMatchingUnreadCountResponse;

